import { z } from "zod";

import { entitySchema } from "@/common/schema/entity";
import { CropUnit } from "@/generated/digitalnisklady.cz/graphql";

const traderSchema = entitySchema.extend(
  z.object({
    logo: z.url(),
    timeFromTrading: z
      .string()
      .nullable()
      .optional()
      .transform((v) => v ?? null),
    timeToTrading: z
      .string()
      .nullable()
      .optional()
      .transform((v) => v ?? null),
    tocUrl: z
      .string()
      .nullable()
      .optional()
      .transform((v) => v ?? null),
  }).shape,
);

const cropUnitSchema = z.enum(CropUnit);

export { cropUnitSchema, traderSchema };
